import {
  fetchCollection
} from './index'

import { workAreaSummarySchema } from '../schemas'

export const WORK_ORDER_WORK_AREA_SUMMARIES_REQUEST = 'WORK_ORDER_WORK_AREA_SUMMARIES_REQUEST'
export const WORK_ORDER_WORK_AREA_SUMMARIES_SUCCESS = 'WORK_ORDER_WORK_AREA_SUMMARIES_SUCCESS'
export const WORK_ORDER_WORK_AREA_SUMMARIES_FAILURE = 'WORK_ORDER_WORK_AREA_SUMMARIES_FAILURE'

export function fetchWorkAreaSummariesForWorkOrder (workOrderId) {
  return fetchCollection({
    url: `/work_orders/${workOrderId}/work_area_summaries`,
    key: 'workAreaSummaries',
    schema: workAreaSummarySchema,
    actions: [ WORK_ORDER_WORK_AREA_SUMMARIES_REQUEST, WORK_ORDER_WORK_AREA_SUMMARIES_SUCCESS, WORK_ORDER_WORK_AREA_SUMMARIES_FAILURE ],
    responseInterceptor: response => ({ ...response, workOrderId })
  })
}



// WEBPACK FOOTER //
// ./src/actions/work-area-summaries.js